import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import Breadcrumbs from "_components/core/Breadcrumbs";
import Paper from "@material-ui/core/Paper";
import SaveButton from "./saveButton";
import { useDispatch, useSelector } from "react-redux";
import { mobileActions } from "_actions";
import { FormField } from "_components/core/FormField";
import Container from "@material-ui/core/Container";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { createFilterOptions } from '@mui/material/Autocomplete';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.HeaderGrayPrgmain,
    padding: 40,
  },
}));

export default function PowGasStartClaim() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState,
    formState: { errors },
  } = useForm();
  const { isDirty } = formState;

  const today = moment().utc().subtract(4, "hours");
  const watchDateNotified = watch("299");
  const dateNotifiedIsToday = watchDateNotified ? watchDateNotified.isSame(new Date(), "day") : false;
  const currentDate = today.format("l");
  const currentTime = today.format("HH:mm");

  useEffect(() => {
    dispatch(mobileActions.getInitial());
  }, [dispatch]);

  const entityID = useSelector((state) => state?.["mobile"]?.["entityID"]);
  const hydration = useSelector((state) => state?.["mobile"]?.["form"]?.["Basic"]);
  const email = useSelector((state) => state?.["mobile"]?.["userId"]);

  const onSubmit = async (data) => {
    const payload = {...data, 304: data[304]?.slice(0,5), email: email}

    dispatch(mobileActions.createInitial(payload, entityID));
    history.push(`/mobile-claim/dashboard`);
  };

  const [breadCrumbs, setBreadCrumbs] = useState();
  useEffect(() => {
    let breadCrumbs_x = [
      { label: "Invoices", url: `/mobile-claim/my-list` },
      {
        label: <span style={{ color: "#c7c2c2" }}>Start A Claim</span>,
      },
    ];
    setBreadCrumbs(breadCrumbs_x);
  }, [classes, entityID]);

  const fields = [
    {
      id: 296,
      type: "text",
    },
    {
      id: 297,
      type: "text",
    },
    {
      type: "divider",
      size: 12,
    },
    {
      id: 298,
      type: "autocomplete",
      options: hydration ? hydration[298]?.["type"]["enumOptions"]?.map((e) => e.value) : [],
    },
    {
      id: 299,
      type: "date",
      maxDate: new Date(currentDate),
    },
    {
      id: 300,
      type: "time",
      maxTime: dateNotifiedIsToday ? currentTime : null,
      customValidationError: dateNotifiedIsToday ? 'Time of Damage cannot exceed the current time' : null,
    },
    {
      type: "divider",
      size: 12,
    },
    {
      id: 301,
      type: "text",
    },
    {
      id: 304,
      type: "autocomplete",
      options: hydration?.[304]?.["type"]["enumOptions"]?.map(option => `${option.value} (${option.label})`) ?? [],
      filterOptions: createFilterOptions({limit: 200}),
    },
    {
      id: 302,
      type: "text",
      readOnly: true,
    },
    {
      id: 303,
      type: "autocomplete",
      options: hydration ? hydration[303]?.["type"]["enumOptions"]?.map((e) => e.value) : [],
    },
    {
      type: "divider",
      size: 12,
    },
    {
      id: 305,
      type: "autocomplete",
      options: hydration ? hydration[305]?.["type"]["enumOptions"] : [],
    },
    {
      id: 306,
      type: "text",
    },
    {
      id: 332,
      type: "textarea",
      md: 6,
    },
  ];

  fields.map((field) => {
    if (hydration && hydration[field.id]) {
      // name
      field.name = `${hydration[field.id]?.id}`;
      // label
      field.label = hydration[field.id]?.label;
      // required
      field.required = hydration[field.id].required;
      // maxLength
      field.maxLength = hydration[field.id].type.maxLength
    }
    return field;
  });


  const zipCode = watch("304");

  useEffect(() => {
    if (zipCode) {
      const zip = zipCode.toString().substring(0, 5);
      const city = zipCode.toString().substring(6).replace(/[()]/g, '');
      if (city) {
        setValue("302", city);
      }
    } else {
      setValue("302", null);
    }
  }, [zipCode]);
  
  return (
    <Container maxWidth="xl">
      <Paper className={classes.root}>
        {hydration && hydration && (
          <Grid container item spacing={3}>
            <Grid item xs={6}>
              <Breadcrumbs mapCrumbs={breadCrumbs || []} />
            </Grid>
            <Grid item xs={6}>
              <SaveButton isDirty={isDirty} handleSubmit={handleSubmit(onSubmit)} />
            </Grid>
            {fields.map((field) => (
              <FormField field={field} register={register} control={control} errors={errors} />
            ))}
          </Grid>
        )}
      </Paper>
    </Container>
  );
}
